<template>
  <luma-empty>
    <b-container>
    <b-card-group deck>
      <b-card v-if="!nextPage"
              style="max-width: 400px; min-width: 400px;">
        <template v-slot:header>
          <h1 class="text-center">{{$t('accounting.charge_account')}}</h1>
        </template>
        <b-form-group>
          <b-form-group
            v-for="(value,key) in balance"
            :key="key"
            :label="$t('accounting')[value['key']]"
            label-align="left">
            <div  v-if="value['key'] === 'payment'"
                  :is="value['tag']"
                  :id="value['key']"
                  :clearable="false"
                  :options="value['options'].map(el=>el.label)"
                  @input="addToBalanceData($event,value)">
            </div>
            <div  v-else
                  :is="value['tag']"
                  :id="value['key']"
                  :placeholder="value['placeholder'] "
                  :disabled="value['disabled'] || undefined"
                  v-model="balanceData[value['key']]"
                  :type="value['type']">

            </div>
          </b-form-group>
          <b-button variant="primary"
                    @click="nextPage = !nextPage"
                    class="col-12 mt-3">
            Weiter
          </b-button>
        </b-form-group>

      </b-card>

      <b-card v-if="nextPage"
              style="min-width:300px; max-width: 400px;">
        <template v-slot:header>
          <h1 class="text-center">Überwesiungsdaten</h1>
        </template>
        <b-card-text>
          <b>Bitte überweisen Sie den Betrag auf folgendes Bankkonto:</b>
        </b-card-text>
        <table>
          <tr v-for="(item,key) in luma_account">
            <td >{{key}}</td>
            <td style="min-width: 24px; height: 36px;">  </td>
            <td v-if="key !== 'Betrag'">{{item}}</td>
            <td v-else><b>{{item}} €</b></td>
          </tr>
        </table>
        <b-button variant="primary"
                  @click="nextPage = !nextPage"
                  class="col-12 mt-3">
          Zurück
        </b-button>
      </b-card>

      <b-card style="min-width:300px; max-width: 400px;">
        <template v-slot:header>
          <h1 class="text-center">{{$t('accounting.account')}}</h1>
        </template>
        <div  >
          <table class="account">
            <tr v-for="(value,key) in balanceResponse"
                :key="key">
              <td>{{$t('accounting')[key]}}</td>
              <td ><p class="m-4"></p></td>
              <td><b>{{value}}</b></td>
              <td>€</td>
            </tr>
          </table>
        </div>

      </b-card>
    </b-card-group>
      </b-container>
  </luma-empty>
</template>

<script>
    import LumaEmpty from "@/layout/LumaEmpty";
    import {ApiRoutesModel} from "@/store/models/layout/api_routes"


    export default {
        name: "luma-accounting-balance",
      components: {LumaEmpty},
      data:()=>({
        balanceData:{},
        nextPage:false,
          getBalance:null
      }),
      computed:{

          luma_account(){
              return {
                Kontoinhaber:'Jan Waldecker',
                IBAN:'DE11 5765 0010 0198 3299 48',
                BIC:'MALADE51MYN',
                Geldinstitut:'Kreissparkasse Mayen',
                Verwendungszweck:'Kd-Nr.: 11425',
                Betrag: this.balanceData.transaction
              }
          },
          balance(){
           return [
             {
               key:'payment',
               tag:'v-select',
               options:[
                 {label:this.$t('accounting.transfer'),key:'transfer'},
                 {label:this.$t('accounting.paypal'),key:'paypal'}
               ]
             },
             {
               key:'transaction',
               type:'number',
               tag:'b-form-input',
               placeholder:'0'
             },
             {
               key:'charge',
               type:'number',
               disabled:true,
               tag:'b-form-input',
               placeholder: '5.00'
             },
             {
               key:'credit',
               type:'number',
               tag:'b-form-input',
               placeholder:'0'
             }
           ]
          },


        balanceResponse(){
            this.getBalance = ApiRoutesModel.find('get.billing.statistic.balance')
            return this.getBalance.response
        }

      },
      methods:{
          addToBalanceData(value,key){
            switch ( key['options'] ) {
              case key['options']:
                const x = key['options'].map(el=> {
                    el.label === value ? this.balanceData[key['key']] = el.key : undefined
                  }
                )
                break
                console.log(value,key,x)
            }
        }
      }
    }
</script>

<style scoped>
.account{
  margin-left: auto;
  margin-right: auto;
  margin-top:20%;
  font-size: larger;
}
</style>



// WEBPACK FOOTER //
// src/components/accounting/balance_accounting/luma-accounting-balance.vue